export const ASIA_EUROPE_TITLE = 'Asia to Europe Container Rates: 20ft & 40ft | FreightRatesMCP'

export const ASIA_EUROPE_DESCRIPTION =
  'Compare Asia to Europe container rates for 20ft and 40HC shipments, transit times, carriers and live lanes from China to North Europe and the Mediterranean.'

export const ASIA_EUROPE_HEADING = 'Asia to Europe container freight rates'

export const ASIA_EUROPE_ANSWER =
  'Asia to Europe container rates vary by origin, destination, carrier, equipment and sailing date. FreightRatesMCP compares current 20ft and 40HC spot rates from major Asian ports to North Europe and the Mediterranean, with transit time and carrier details. Rates are indicative and updated daily; request a firm all-in quote before booking.'

export const ASIA_EUROPE_FAQ = [
  {
    q: 'How much does a container from Asia to Europe cost?',
    a: 'The price depends on the Asian origin, European destination, container size, carrier and sailing date. Use the live lane cards on this page to compare current 20ft and 40HC spot rates, then request a firm all-in quote including applicable local charges and surcharges.',
  },
  {
    q: 'What is included in the Asia to Europe rate shown?',
    a: 'The displayed figures are indicative ocean spot rates from public carrier listings. They are useful for market comparison but may not include every origin, destination, documentation, customs or seasonal surcharge. A firm quote confirms the complete charge set for a shipment.',
  },
  {
    q: 'How long does shipping from Asia to Europe take?',
    a: 'Transit time varies by port pair and whether the service is direct or uses transshipment. Each live lane card shows its current port-to-port transit estimate so you can compare faster services with lower-priced options.',
  },
  {
    q: 'How often are Asia to Europe freight rates updated?',
    a: 'FreightRatesMCP refreshes public carrier spot-rate listings daily and calculates the trade benchmark from the available lane data. Always request a firm quote before booking because capacity and surcharges can change quickly.',
  },
]
